<template>
	<div class="page">
		<div title="projectPlate" is='headered'></div>
		<div class="talentTop">
			<div class="title">
				<div class="title_seld">项目成长的专业顾问</div>
				<div class="talentBox_l">
				<div class="talentBox_l_main">
					<div @click="goToPage1()">卓越大奖</div>
					<div @click="goToPage2()">管理咨询</div>
					<div @click="goToPage3()">企业培训</div>
				</div>
			</div>
			</div>
			<!--<img class="talentImg" src="../assets/project_img1.png"/>-->
			<img class="talentImg" src="../assets/projectBanner.png"/>
			
		</div>
		<!--人才板块主体内容-->
			
		<!--卓越大奖-->
		<div class="fullBox">
			<div class="fullBox_main">
				<div class="title">IPMA国际卓越项目管理大奖"管理届奥斯卡"</div>
				<div class="fullBox_main_df">
					<div class="fullBox_main_l">
						<img src="../assets/project_img2.png"/>
						<img src="../assets/projectT_img4.png"/>
					</div>
					<div class="fullBox_main_r">
						<div>							
							<div>(IPMA—International Project Management Award，简称IPMA PM Award)。是由国际项目管理协会IPMA设立的专业奖项，宗旨是鼓励和表彰通过专业项目管理取得卓越绩效的团队，在全球树立具有创新精神项目管理典范。该奖项1997年起源于德国项目管理协会，“卓越项目管理模型”是借鉴欧洲质量管理奖模型，在著名的EFQM模型 (欧洲质量管理基金会 European Foundation for Quality Management）该奖项从2001 年正式设为世界性奖项，现被国际管理界称为国际项目管理领域的 “奥斯卡奖”，在一年一度的全球项目管理大会上，向那些取得巨大成绩的团队，颁发国际项目管理卓越大奖。</div>
						</div>
						<div>					
							<div>我国在2005年首次有项目入围获奖。到2020年我国一共有22个项目获得IPMA国际项目管理卓越大奖，其中金奖10个，银奖9个，铜奖3个。中国认证委员会推送国际项目管理大奖评估师近50人，每年参与到世界各地的报奖项目上去现场评审。</div>
						</div>
						<div>
							<div>2001年，国际项目管理协会IPMA正式推出卓越项目模型（Project Excellence Model）对项目进行评估，同时开展了以项目管理模型为准则的项目管理卓越大奖评选活动。</div>
						</div>
						<div>
							<div>“卓越项目管理模型”是借鉴欧洲质量管理奖模型，在著名的EFQM模型 (欧洲质量管理基金会European Foundation for Quality Management 欧洲质量奖及其他许多国家级质量奖的申报评定基础) 基础上创建的“卓越项目管理模型”有多个评估标准：“人员目标”“过程资源” “项目结果”三方面。</div>
						</div>
						<div class="fullBox_imgdf">
							<img src="https://static.feijingbang.com/upload/1f15020b273f4c55acee21f3d35fff35"/>
							<img src="../assets/projectT_img2.png"/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--名单-->
		<div class="projectList">
			<div class="projectList_item">
				<div class="projectList_item_l">2020年</div>
				<div class="projectList_item_r">
					<div>北京大兴机场建设指挥部“北京新机场项目”获得金奖</div>
					<div>东电一公司“孟加拉火电厂项目”获得银奖</div>
					<div>中国能建（西北院&天津电建联合体）的“火力发电站项目”获得铜奖</div>
				</div>
			</div>
			<div class="projectList_item">
				<div class="projectList_item_l">2019年</div>
				<div class="projectList_item_r">
					<div>神华宁夏煤集团“400万吨/年煤制油项目”获得超大型项目银奖</div>
				</div>
			</div>
			<div class="projectList_item">
				<div class="projectList_item_l">2018年</div>
				<div class="projectList_item_r">
					<div>重庆联盛工程的“内蒙古少数民族文化体育中心”在芬兰获得金奖</div>
					<div>中国云南石化“1300万吨/年炼油项目”在芬兰国际会议上获银奖</div>
				</div>
			</div>
			<div class="projectList_item">
				<div class="projectList_item_l">2017年</div>
				<div class="projectList_item_r">
					<div>山东电力工程咨询院“湄洲湾2x1000 MV工程”在第30届哈萨克斯坦国际上获金奖。</div>
				</div>
			</div>
			<div class="projectList_item">
				<div class="projectList_item_l">2015年</div>
				<div class="projectList_item_r">
					<div>江苏南京城建“南京市公共卫生医疗中心”巴拿马第29届国际大会获大型项目金奖。</div>
				</div>
			</div>
			<div class="projectList_item">
				<div class="projectList_item_l">2013年</div>
				<div class="projectList_item_r">
					<div>广西石化“千万吨炼油项目”在克罗地亚第27届国际大会获特大型项目金奖。</div>
				</div>
			</div>
			<div class="projectList_item">
				<div class="projectList_item_l">2012年</div>
				<div class="projectList_item_r">
					<div>江苏建业恒安工程管理公司的“长泾古镇改扩建项目” 在希腊第26届全球大会获银奖。</div>
				</div>
			</div>
			<div class="projectList_item">
				<div class="projectList_item_l">2011年</div>
				<div class="projectList_item_r">
					<div>西安世界园艺博览会筹备办公室的“中国西安2011世界园艺博览会筹备项目” 在第25届澳大利亚布里斯班全球大会上面获国际卓越大奖铜奖。</div>
				</div>
			</div>
			<div class="projectList_item">
				<div class="projectList_item_l">2010年</div>
				<div class="projectList_item_r">
					<div>中海石油炼化有限责任公司“中国海洋石油总公司惠州炼油项目”在土耳 其伊斯坦布尔第24届全球大会上面获特大型项目金奖；</div>
					<div>同济大学的“中国2010年上海世博会总体项目管理咨询”获银奖。</div>
				</div>
			</div>
			<div class="projectList_item">
				<div class="projectList_item_l">2009年</div>
				<div class="projectList_item_r">
					<div>西门子中国公司的“北京首都机场三号航站楼行李系统 ”项目在芬兰赫尔辛基第23届全球项目管理大会获大型项目金奖；</div>
					<div>中铁隧道集团有限公司“广深港客运专线狮子洋隧道”获大型项目银奖。</div>
				</div>
			</div>
			<div class="projectList_item">
				<div class="projectList_item_l">2008年</div>
				<div class="projectList_item_r">
					<div>南京城建项目管理发展有限公司的“侵华日军南京大屠杀纪念馆扩建工程”项目在意大利罗马第22届全球大会上获国际项目管理大奖银奖。</div>
				</div>
			</div>
			<div class="projectList_item">
				<div class="projectList_item_l">2007年</div>
				<div class="projectList_item_r">
					<div>江苏索普(集团)有限公司的 “15万吨/年醋酸技术扩建项目”在波兰克拉科夫第21届全球项目管理大会上获国际大奖金奖；</div>
					<div>首都信息发展股份有限公司“北京医疗保险信息系统项目”获国际银奖；</div>
					<div>贵州中水建设项目管理公司“贵州大方落脚河水电站建设项目”获银</div>
				</div>
			</div>
			<div class="projectList_item">
				<div class="projectList_item_l">2006年</div>
				<div class="projectList_item_r">
					<div>中国空间技术研究院“神舟六号载人飞船项目”在中国上海第20届全球大会上获大型项目组金奖；</div>
					<div>天津天士力制药股份公司“全面项目化管理组织变革项目”获银奖；</div>
					<div>中国海外工程总公司“中海外项目管理体系建设项目”获国际大奖铜奖。 </div>
				</div>
			</div>
			<div class="projectList_item">
				<div class="projectList_item_l">2005年</div>
				<div class="projectList_item_r">
					<div>山东中创软件工程股份有限公司的“山东省高速公路信息系统建设项目”在印度第19届全球大会上获国际项目管理大奖银奖。 </div>
				</div>
			</div>
			<div class="timeFoot_img">
				<img src="../assets/timeFoot_img.png"/>
			</div>
		</div>
		<!--企业培训&管理咨询-->
		<div class="project_item">
			<div class="projectTitle">管理咨询</div>
			<div class="projectRow">
				<div class="projectRow_item">
					<div class="title">单项目管理咨询</div>
					<div class="text"></div>
					<div class="text">项目前期策划论证评估</div>
					<div class="text"></div>
					<div class="text">项目实施辅导计划控制</div>
					<div class="text"></div>
					<div class="text">项目管理后评价</div>
				</div>
				<div class="projectRow_item">
					<div class="title">项目管理体系构建</div>
					<div class="text"></div>
					<div class="text">项目层管理手册</div>
					<div class="text"></div>
					<div class="text">企业层管理手册</div>
					<div class="text"></div>
					<div class="text">项目集管理手册</div>
				</div>
				<div class="projectRow_item">
					<div class="title">企业项目化咨询</div>
					<div class="text"></div>			
					<div class="text">企业项目管理成熟度</div>
					<div class="text"></div>		
					<div class="text">组织、流程和绩效管理体系</div>
					<div class="text"></div>		
					<div class="text">项目治理体系</div>
				</div>
			</div>
		</div>
		<div style="margin-bottom: 120px;" class="project_item">
			<div class="projectTitle">企业培训</div>
			<div class="projectRow">
				<div style="padding-bottom: 40px;" class="projectRow_item">
					<div class="title">基础知识</div>
					<div class="text">项目管理最佳实践</div>
					<div class="text"></div>
					<div class="text">项目实战中的工具与模板</div>
					<div class="text"></div>
					<div class="text">项目式案例演练</div>
				</div>
				<div style="padding-bottom: 40px;" class="projectRow_item">
					<div class="title">项目全周期实战培训</div>
					<div class="text">项目管理体系综述；组织与团队建设； 项目决策分析与评价；计划与控制（项目范围、时间、成本、质量管理）； 项目综合要素分析（信息、沟通、冲突、风险）；项目管理综合应用案例</div>
				</div>
				<div style="padding-bottom: 40px;" class="projectRow_item">
					<div class="title">企业项目化管理实践</div>
					<div class="text">企业项目管理成熟度模型</div>
					<div class="text"></div>
					<div class="text">项目治理；项目集管理</div>
					<div class="text"></div>
					<div class="text">项目管理办公室（PMO） </div>
				</div>
			</div>
		</div>
		<!--公共底部-->
		<div is='footed'></div>
	</div>
</template>

<script>
	import headered from '@/components/header';
	import footed from '@/components/foot';
	export default {
		name: 'index',
		components: {
			headered,
			footed
		},
		data() {
			return {
				project_Index:0,
				
			}
		},
		mounted() {
			window.addEventListener('scroll', this.pro_scrolled);
		},
		destroyed() {
			window.removeEventListener('scroll', this.pro_scrolled);
		},
		methods:{
			goToPage1(){
				this.goTo(500)
			},
			goToPage2(){
				this.goTo(1200)
			},
			goToPage3(){
				this.goTo(2800)
			},
			goTo(target) {
				var scrollT = document.body.scrollTop || document.documentElement.scrollTop
				if(scrollT > target) {
					var timer = setInterval(function() {
						var scrollT = document.body.scrollTop || document.documentElement.scrollTop
						var step = Math.floor(-scrollT / 50);
						document.documentElement.scrollTop = document.body.scrollTop = step + scrollT;
						if(scrollT <= target) {
							document.body.scrollTop = document.documentElement.scrollTop = target;
							clearTimeout(timer);
						}

					}, 10)
				} else if(scrollT == 0) {
					var timer = setInterval(function() {
						var scrollT = document.body.scrollTop || document.documentElement.scrollTop
						var step = Math.floor(300 / 5 * 0.7);
						document.documentElement.scrollTop = document.body.scrollTop = step + scrollT;
						console.log(scrollT)
						if(scrollT >= target) {
							document.body.scrollTop = document.documentElement.scrollTop = target;
							clearTimeout(timer);
						}
					}, 10)

				} else if(scrollT < target) {
					var timer = setInterval(function() {
						var scrollT = document.body.scrollTop || document.documentElement.scrollTop
						var step = Math.floor(scrollT / 50);
						document.documentElement.scrollTop = document.body.scrollTop = step + scrollT;
						if(scrollT >= target) {
							document.body.scrollTop = document.documentElement.scrollTop = target;
							clearTimeout(timer);
						}

					}, 10)

				} else if(target == scrollT) {
					return false;
				}
			},
			titleScroll(){
//				console.log( this.$refs.titleList.scrollTop)
			},
			pro_scrolled(){
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;　　		
			},
//			jumped(index){
//				this.project_Index = index
//				let jump = document.querySelectorAll('.projectList_r_item')
//				//				// 获取需要滚动的距离
//				let total = jump[index].offsetTop - 210
//				document.documentElement.scrollTop = total
//				window.pageYOffset = total
//			},
			
		}
	}
</script>

<style scoped="scoped">
	/*顶部*/
	
	.talentTop {
		width: 1200px;
		margin: 0 auto;
		margin-top: 30px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 30px;
	}
	
	.talentTop>.title {
		height: 387px;
		padding-top: 96px;
	}
	
	.talentTop>.title .title_seld {
		line-height: 63px;
		font-size: 48px;
		text-align: left;
		margin-bottom: 100px;
		font-weight: bold;
	}
	
	.talentTop .talentImg {
		width: 690px;
		height: 387px;
		border-radius: 10px;
	}
	/*企业培训*/	
	.project_item{
		width: 1200px;
		margin: 0 auto;
		margin-bottom: 30px;
	}
	.projectTitle{
		text-align: center;
		margin-bottom: 30px;
		line-height: 48px;
		font-size: 36px;
		font-weight: bold;
	}
	.projectRow{
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		align-items: center;	
	}
	.projectRow_item{
		width: 384px;
		min-height: 352px;
		border-radius: 10px;
		padding: 60px;
		padding-bottom: 20px;
		background-color: #F0F0F0;
	}
	.projectRow_item>.title{
		line-height: 26px;
		font-size: 20px;
		font-weight: bold;
		margin-bottom: 30px;
		text-align: center;
		color: #333;
	}
	.projectRow_item>.text{
		min-height: 28px;
		line-height: 28px;
		font-size: 18px;
		color: #51565D;
		text-align: left;
		text-indent: 2em;
	}
	/*卓越大奖*/
	.fullBox{
		width: 100%;
		min-width: 1200px;
		padding-top: 90px;
		padding-bottom: 90px;
		background-color: #F5F5F5;
		margin-bottom: 30px;
	}
	.fullBox .fullBox_main{
		width: 1200px;
		margin: 0 auto;
	}
	.fullBox .fullBox_main>.title{
		line-height: 48px;
		font-size: 36px;
		font-weight: bold;
		margin-bottom: 40px;
	}
	.fullBox .fullBox_main>.s_title{
		line-height: 24px;
		font-size: 16px;
		color: #51565D;
		margin-bottom: 40px;
	}
	.fullBox_main_df{
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: flex-start;
	}
	.fullBox_main_l{
		width: 260px;
		line-height: 26px;
		font-size: 20px;
		font-weight: 560;
		margin-right: 30px;
	}
	.fullBox_main_l div{
		margin-bottom: 20px;
	}
	.fullBox_main_l img{
		width: 162px;
		height: 306px;
		margin: 0 auto;
		margin-bottom: 30px;
	}
	.fullBox_main_r{
		width: 850px;
	}
	.fullBox_main_r>div{
		width: 850px;
		line-height: 24px;
		font-size: 16px;
		color: #51565D;
		text-align: left;
		text-indent: 2em;
		/*display: flex;
		flex-direction: row;
		justify-content: flex-start;*/
		/*align-items: center;*/
		margin-bottom: 20px;
	}
	.fullBox_imgdf{
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: flex-start;
	}
	.fullBox_main_r>.fullBox_imgdf img{
		width: 380px;
		height: 232px;
	}
	/*名单*/
	.projectList{
		width: 1200px;
		margin: 0 auto;
	}
	.projectList_item{
		width: 1200px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: flex-start;
		margin-bottom: 20px;
	}
	.projectList_item_l{
		width: 100px;
		line-height: 24px;
		font-size: 24px;
		color: #5872B9;
	}
	.projectList_item_r{
		width: 850px;
	}
	.projectList_item_r div{
		min-height: 24px;
		line-height: 24px;
		font-size: 18px;
		color: #51565D;
		text-align: left;
		position: relative;
		margin-bottom: 10px;
	}
	.projectList_item_r div::after{
		content: "";
		display: block;
		width: 4px;
		height: 4px;
		background-color: #0080FF;
		position: absolute;
		top: 10px;
		left: -12px;
	}
	/*左侧控制栏*/
	
	.talentBox_l {
		width: 100px;
		height: 146px;
	}
	
	.talentBox_l_main {
		width: 100px;
		height: 126px;
		border-left: 2px solid #EFF0F1;
	}

	.talentBox_l_main>div {
		width: 100px;
		text-align: right;
		margin-bottom: 27px;
		line-height: 24px;
		font-size: 18px;
		color: #51565D;
		cursor: pointer;
	}
	
	.talentBox_l_main>div:nth-child(3) {
		margin-bottom: 0px;
	}
	
	.talentBox_l_main>.talentBox_l_sel {
		color: #4A7CFF;
	}
	
	.talentBox_l_main>.talentBox_l_sel::after {
		content: "";
		display: block;
		width: 2px;
		height: 24px;
		background-color: #4A7CFF;
		position: absolute;
		left: -2px;
		bottom: 0px;
	}
	.timeFoot_img{
		margin: 30px auto;
	}
	/*右侧主体栏*/
	
	.talentBox_r {
		width: 792px;
	}
</style>


// WEBPACK FOOTER //
// src/views/projectPlate.vue